import { UpdateShiftPage } from '@/components/shifts/UpdateShiftPage';

export default function UpdateShiftsPage() {
  return <UpdateShiftPage />;
} 